import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {CustomFormControl} from '../components/controls/CustomFormControl';
import {Validation} from '../models/WebFormTemplate';

export function atLeastOneCheckboxValidator(validation: Validation, controls: Map<string, CustomFormControl>): ValidatorFn {
  return (_: AbstractControl): ValidationErrors | null => {
    for (const checkbox of validation.controls) {
      const targetControl = controls.get(checkbox);
      if (targetControl && targetControl.value === true) {
        return null;
      }
    }

    return { noCheckboxesSelected: validation.customErrorMessage };
  };
}
